import React from 'react';

export default function InfoSections() {
  return (
    <div className="max-w-[1400px] mx-auto px-4 py-8 space-y-8 border-t border-gray-200">
      <div className="grid sm:grid-cols-2 gap-8">
        <section className="space-y-4">
          <h2 className="text-lg font-bold font-mono">About Bitcoin Exchange Fees in Canada</h2>
          <div className="prose prose-sm max-w-none font-mono text-sm leading-relaxed space-y-2">
            <p>
              Squeeze every SAT out of your Bitcoin transactions. This tool provides real-time 
              comparisons across major Canadian exchanges, considering:
            </p>
            <ul className="list-none space-y-1 pl-4">
              <li>• Buy/sell fees and spreads</li>
              <li>• Deposit and withdrawal fees</li>
              <li>• Payment method restrictions</li>
              <li>• Exchange-specific features</li>
            </ul>
            <p className="text-sm">
              Note: Actual amounts may vary due to market fluctuations. Prices are approximations and network fees and spreads can fluctuate. Always verify final amounts with the exchange before trading.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-lg font-bold font-mono">How to Compare Cryptocurrency Exchange Fees</h2>
          <div className="space-y-3 font-mono text-sm">
            <div className="space-y-1">
              <div className="flex gap-2">
                <span className="font-bold">1.</span>
                <span className="font-bold">Toggle Buy/Sell</span>
              </div>
              <p className="pl-6 text-gray-600">
                Switch between buying and selling Bitcoin to compare fees for each direction.
              </p>
            </div>

            <div className="space-y-1">
              <div className="flex gap-2">
                <span className="font-bold">2.</span>
                <span className="font-bold">Enter Amount</span>
              </div>
              <p className="pl-6 text-gray-600">
                Input your CAD amount to see how much Bitcoin you'll receive or need to sell.
              </p>
            </div>

            <div className="space-y-1">
              <div className="flex gap-2">
                <span className="font-bold">3.</span>
                <span className="font-bold">BTC/SATs Toggle</span>
              </div>
              <p className="pl-6 text-gray-600">
                Switch between BTC (฿) and Satoshis (sats). 1 BTC = 100,000,000 sats.
              </p>
            </div>

            <div className="space-y-1">
              <div className="flex gap-2">
                <span className="font-bold">4.</span>
                <span className="font-bold">Compare Rates</span>
              </div>
              <p className="pl-6 text-gray-600">
                Exchanges are sorted by best rate. Click exchange names to visit their websites.
              </p>
            </div>
          </div>
        </section>
      </div>
      
      <section className="space-y-4">
        <h2 className="text-lg font-bold font-mono">Popular Canadian Bitcoin Exchanges</h2>
        <div className="prose prose-sm max-w-none font-mono text-sm leading-relaxed">
          <p>
            We compare fees across major Canadian cryptocurrency platforms including NDAX, Shakepay, Newton, Bull Bitcoin, 
            Bitbuy, Coinbase, Kraken, Netcoins, and more. Each platform has different fee structures, payment methods, 
            and withdrawal options that impact your overall costs when trading Bitcoin in Canada.
          </p>
        </div>
      </section>
    </div>
  );
}